import BaseCheckbox, { BaseCheckboxProps } from 'components/base-checkbox';
import styles from './styles.module.scss';

export type RadioButtonProps = Pick<
  BaseCheckboxProps,
  'checked' | 'onChange' | 'label' | 'labelPosition' | 'className' | 'children' | 'style'
>;

const RadioButton: React.FC<RadioButtonProps> = (props) => {
  return <BaseCheckbox {...props} inputClassName={styles.input} markClassName={styles.radio} />;
};

export default RadioButton;
